module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Pro Max Gold.69eb349d.png";